/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import {useDispatch} from 'react-redux';

import {Link} from 'react-router-dom';
import {useFormik} from 'formik';
import {getUserByToken, login, getBranchByToken, getPermissonByName} from '../core/_requests';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import {useAuth} from '../core/Auth';
import {useIntl} from 'react-intl';

import * as actionsGlobal from 'src/setup/redux/global/Actions';
import {Languagess} from 'src/_metronic/partials/layout/header-menus/Languages2';

const initialValues = {
  userName: '',
  password: '',
};

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {saveAuth, setCurrentUser} = useAuth();
  const intl = useIntl();

  const loginSchema = Yup.object().shape({
    userName: Yup.string().required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})),
    password: Yup.string().required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true);
      try {
        const res = await login(values.userName, values.password);
        const auth = res.data;
        saveAuth(res.data);
        // console.log(res?.message);
        const {data: user} = await getUserByToken(auth.token);
        const {data: branches} = await getBranchByToken(auth.token);
        const {data: permissons} = await getPermissonByName(user?.userName, auth.token);
        user.branches = branches || [];
        user.permissons = permissons || [];
        dispatch(actionsGlobal.setBranches(branches));

        // if (branches.length > 0) {
        //   dispatch(actionsGlobal.setCurrentBranch(branches[0]));
        // }
        setCurrentUser(user);
      } catch (error) {
        // console.log(error);
        saveAuth(undefined);
        setSubmitting(false);
        setLoading(false);
        setStatus(intl.formatMessage({id: 'AUTH.VALIDATION.INVALID_LOGIN'}));
      }
    },
  });

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>{intl.formatMessage({id: 'LOGINPAGE.LOGINTITLE'})}</h1>
      </div>

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <></>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {intl.formatMessage({id: 'LOGINPAGE.ACCOUNT'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'LOGINPAGE.ACCOUNT'})}
          {...formik.getFieldProps('userName')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.userName && formik.errors.userName},
            {
              'is-valid': formik.touched.userName && !formik.errors.userName,
            }
          )}
          type='text'
          name='userName'
          autoComplete='off'
        />
        {formik.touched.userName && formik.errors.userName && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.userName}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>
              {intl.formatMessage({id: 'LOGINPAGE.PASSWORD'})}
            </label>
            {/* end::Label */}
            {/* begin::Link */}
            {/* <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{marginLeft: '5px'}}
            >
              Forgot Password ?
            </Link> */}
            {/* end::Link */}
          </div>
        </div>
        <input
          type='password'
          placeholder={intl.formatMessage({id: 'LOGINPAGE.PASSWORD'})}
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className='indicator-label'>
              {intl.formatMessage({id: 'LOGINPAGE.LOGINBUTTON'})}
            </span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'LOGINPAGE.PROCESSING'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* <div class='text-gray-500 text-center fw-semibold fs-6'>
        {intl.formatMessage({id: 'LOGINPAGE.REGISTRATIONTITLE'})}
        <Link className='link-primary' to='/auth/registration'>
          {intl.formatMessage({id: 'LOGINPAGE.SIGNIN'})}
        </Link>
      </div> */}
      <div class='text-gray-500 text-center fw-semibold fs-6'>
        {intl.formatMessage({id: 'LOGINPAGE.FORGOTPASSTITLE'})}
        <Link className='link-primary' to='/auth/forgot-password'>
          {intl.formatMessage({id: 'LOGINPAGE.FORGOTPASSLINK'})}
        </Link>
      </div>
      <Languagess />
      {/* end::Action */}
    </form>
  );
}
